import { Button } from '@mui/material';
import SteamIcon from '../SteamIcon';

const steamButtonSx = {
  background: 'linear-gradient(180deg, #2a475e 0%, #1b2838 100%)',
  border: '1px solid rgba(102, 192, 244, 0.45)',
  color: '#f8fafc',
  fontWeight: 700,
  boxShadow: '0 4px 14px rgba(0, 0, 0, 0.35), inset 0 1px 0 rgba(255, 255, 255, 0.08)',
  '&:hover': {
    background: 'linear-gradient(180deg, #3d6a8a 0%, #2a475e 100%)',
    borderColor: 'rgba(102, 192, 244, 0.75)',
    boxShadow: '0 6px 20px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.1)',
  },
  '& .MuiButton-startIcon': {
    marginRight: 1.25,
    marginLeft: -0.25,
  },
};

export default function SteamSignInButton({ onClick, size = 'medium', className, fullWidth = false }) {
  const iconSize = size === 'large' ? 34 : 28;

  return (
    <Button
      variant="contained"
      size={size}
      startIcon={<SteamIcon size={iconSize} />}
      onClick={onClick}
      className={className}
      fullWidth={fullWidth}
      sx={{
        ...steamButtonSx,
        ...(size === 'large' && {
          py: { xs: 1.25, sm: 1.5 },
          px: { xs: 2.5, sm: 3.5 },
          fontSize: { xs: '0.95rem', sm: '1.05rem' },
        }),
        whiteSpace: 'nowrap',
      }}
    >
      Sign in with Steam
    </Button>
  );
}
